import React, { useCallback, useState } from "react";
import { Card, Icon, Statistic } from "antd";
import StatisticPeriod from "./StatisticsPeriod";
import { getCardsStatistics } from "../../service/cards";

export default function CardsStatistics() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const onChange = useCallback(async (range) => {
    // setLoading(true);
    const data = await getCardsStatistics({ range });
    setData({ total: data.total, range: data.range.toString() })
    // setLoading(false);
  }, []);
  return (
    <Card>
      <Statistic
        title={<span>Cards <StatisticPeriod onChange={onChange}/></span>}
        value={data.total}
        prefix={<Icon type="border" />}
        suffix={<span className="color-grey">{data.range}</span>}
      />
    </Card>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/CardsStatistics.js